const state = {
  auth: localStorage.getItem('ut') || '',
  roleList: (() => {
    try {
      const stored = localStorage.getItem('roleList')
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  })(),
}
const getters = {
  isAuthenticated: (state) => !!state.auth,
  getAuth: (state) => state.auth,
  getUserName: (state) =>
    state.userName || localStorage.getItem('userName') || '',
  getToken: (state) => state.ut || localStorage.getItem('ut') || '',
  getRoleList: (state) => {
    if (
      state.roleList &&
      Array.isArray(state.roleList) &&
      state.roleList.length > 0
    ) {
      return state.roleList
    }
    try {
      const stored = localStorage.getItem('roleList')
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  },
}

const mutations = {
  SET_AUTH(state, token) {
    state.auth = token
    localStorage.setItem('ut', token)
  },
  CLEAR_AUTH(state) {
    state.auth = ''
    localStorage.removeItem('ut')
  },
  SET_USER(state, userName) {
    state.userName = userName
    localStorage.setItem('userName', userName)
  },
  CLEAR_USER(state) {
    state.userName = ''
    localStorage.removeItem('userName')
  },
  CLEAR_ROLE(state) {
    state.roleList = []
    localStorage.removeItem('roleList')
  },
  SET_ROLE(state, roleList) {
    state.roleList = roleList
    localStorage.setItem('roleList', JSON.stringify(roleList))
  },
}
const actions = {
  login({ commit }, token) {
    commit('SET_AUTH', token)
  },
  logout({ commit }) {
    commit('CLEAR_AUTH')
  },
  setUser({ commit }, userName) {
    commit('SET_USER', userName)
  },
  clearUser({ commit }) {
    commit('CLEAR_USER')
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
